import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { NAVIGATION } from './constants';
import { NavContainer, NavList, NavLink, LogoContainer, LogoLink, HamburgerButton, HamburgerIcon, MobileNavList, } from './Navigation.styles';
import rkLogo from '@assets/rk-logo.svg';
import { useAnalytics } from '../../../hooks/useAnalytics';
const Navigation = ({ activeSection = 'home' }) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const { trackClick } = useAnalytics();
    const handleNavClick = (href, label) => {
        if (typeof window === 'undefined')
            return;
        // Track navigation click
        trackClick(`nav_${label.toLowerCase().replace(/\s+/g, '_')}`, 'navigation', {
            destination: href,
        });
        if (href === '#') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        else {
            const target = document.querySelector(href);
            if (target) {
                target.scrollIntoView({ behavior: 'smooth' });
            }
        }
        // Close mobile menu after navigation
        setIsMobileMenuOpen(false);
    };
    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
        trackClick('mobile_menu_toggle', 'button', {
            is_open: !isMobileMenuOpen,
        });
    };
    return (_jsxs(NavContainer, { children: [_jsx(HamburgerButton, { onClick: toggleMobileMenu, "aria-label": "Toggle menu", children: _jsxs(HamburgerIcon, { "$isOpen": isMobileMenuOpen, children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {})] }) }), _jsx(LogoContainer, { children: _jsx(LogoLink, { onClick: () => handleNavClick('#', 'Home'), href: "#", "aria-label": "Home", children: _jsx("img", { src: rkLogo, alt: "Raja Kedia - Portfolio Home" }) }) }), _jsx(NavList, { children: NAVIGATION.map((item) => (_jsx("li", { children: _jsx(NavLink, { onClick: () => handleNavClick(item.href, item.label), "$active": activeSection === item.href.substring(1) || (item.href === '#' && activeSection === 'home'), children: item.label }) }, item.href))) }), _jsx(MobileNavList, { "$isOpen": isMobileMenuOpen, children: NAVIGATION.map((item) => (_jsx("li", { children: _jsx(NavLink, { onClick: () => handleNavClick(item.href, item.label), "$active": activeSection === item.href.substring(1) || (item.href === '#' && activeSection === 'home'), children: item.label }) }, item.href))) })] }));
};
export default Navigation;
